<template>
  <v-container v-if="user">
    <v-card>
      <v-card-title class="text-center teal lighten-3 accent-4 white--text">
        Reporte de pedidos
      </v-card-title>
      <form
        ref="form"
        @submit.prevent="getReportes() && getReportesCumplimiento()"
      >
        <!-- Fecha inicial y fecha fin  -->
        <v-row class="mx-2 mt-1">
          <v-col cols="6" md="3">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fechaInicial"
                  label="Fecha inicial"
                  prepend-icon="mdi-calendar"
                  readonly
                  required
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fechaInicial"
                no-title
                color="teal lighten-3"
                locale="es-MX"
                @input="menu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" md="3">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fechaFin"
                  label="Fecha fin"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fechaFin"
                no-title
                color="teal lighten-3"
                locale="es-MX"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" md="4">
            <v-select
              v-model="sucursalesSelected"
              :items="sucursales"
              label="Sucursal"
              multiple
              chips
              deletable-chips
              @change="mostrarSucursal"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="mx-2 mt-1">
          <v-col cols="6" md="2">
            <v-btn type="submit" :loading="loadingBtn" class="mt-3"
              >Enviar
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </v-card>

    <v-card v-if="dialogAllReportes" class="mt-5">
      <v-container fluid>
        <v-card-title>Reporte de pedidos</v-card-title>
        <v-card-text v-if="pedidosSucursales.length > 0">
          <div class="subtitle-1 mb-3">
            De {{ fechaInicial }} a {{ fechaFin }}
          </div>

          <div v-for="(sucursal, index) in pedidosSucursales" :key="index">
            <div
              class="text-h5 mt-4"
              v-if="sucursalesSelected[index] === 'LaPaz'"
            >
              La Paz
            </div>
            <div
              class="text-h5 mt-4"
              v-else-if="sucursalesSelected[index] === 'Obregon'"
            >
              Obregón
            </div>
            <div class="text-h5 mt-4" v-else>
              {{ sucursalesSelected[index] }}
            </div>
            <div class="text-h6">
              Pedidos entregados : {{ sucursal.pedidos_entregados }}
            </div>
            <div class="text-h6">
              Duracion promedio de pedidos :
              {{ formatMinutes(sucursal.totalMinutos) }}
            </div>
            <apexchart
              :options="chartOptions"
              :series="sucursal.series"
              type="bar"
              height="300"
            ></apexchart>
          </div>
        </v-card-text>
        <v-select
          v-model="usuarioSeleccionado"
          :items="usuariosDisponibles"
          label="Filtrar por usuario"
          clearable
          @change="filtrarPorUsuario"
        ></v-select>
        <apexchart
          :options="chartOptions2"
          :series="chartSeries2"
          type="bar"
          height="350"
        ></apexchart>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import VueApexCharts from "vue-apexcharts";
import { intervalToDuration } from "date-fns";

export default {
  data() {
    return {
      usuariosDisponibles: [],
      usuarioSeleccionado: null,
      rangoHorario: [8, 17],
      fechaInicial: "",
      fechaFin: "",
      sucursalesSelected: [],
      dialogReportes: false,
      dialogAllReportes: false,

      datos: [],

      menu: false,
      menu2: false,

      loadingBtn: false,

      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#333"],
            fontSize: "14px",
          },
          formatter: function (val) {
            const days = Math.floor(val / (24 * 60));
            const hours = Math.floor((val % (24 * 60)) / 60);
            const mins = val % 60;

            if (days === 0) {
              if (hours === 0) {
                return `${mins}m`;
              } else {
                return `${hours}h, ${mins}m`;
              }
            } else {
              if (mins === 0) {
                return `${days}d, ${hours}h`;
              } else {
                return `${days}d, ${hours}h, ${mins}m`;
              }
            }
          },
          background: {
            enabled: true,
            foreColor: "#fff",
            borderRadius: 2,
            padding: 4,
            opacity: 0.5,
            borderWidth: 1,
            borderColor: "#fff",
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            // dataLabels: {
            //   position: "top",
            // },
          },
        },
        xaxis: {
          categories: [
            "Pedido creado",
            "Revisión de crédito",
            "Confirmación",
            "Facturación",
            "Prep. en almacén",
            "Preparado",
            "En ruta entrega",
          ],
          labels: {},
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-yaxis-label",
            },
          },
          title: {
            text: "Duración promedio (minutos)",
            rotate: -90,
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: "16px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 525,
              cssClass: "apexcharts-yaxis-title",
            },
          },
        },
        fill: {
          opacity: 1,
        },
        colors: ["#42A5F5"],
        legend: {
          position: "top",
          horizontalAlign: "left",
        },
      },

      chartSeries: [
        {
          name: "Tiempo (min)",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
      ],

      pedidosSucursales: [],

      sucursales: [
        {
          text: "Mexicali",
          value: "Mexicali",
        },
        {
          text: "Culiacan",
          value: "Culiacan",
        },
      ],
      nombresSucursales: ["Mexicali", "Culiacan"],
      pedidosCumplimiento: [],
      chartOptions2: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        annotations: {
          //poner anotaciones en el grafico en el horario de 8am a 5pm
          xaxis: [
            {
              x: 32, // 8 AM
              strokeDashArray: 4, // Línea punteada
              borderColor: "#FF4560", // Color de la línea
              label: {
                style: {
                  color: "#fff",
                  background: "#FF4560",
                },
                text: "Inicio Jornada (8 AM)",
                orientation: "horizontal",
                textAnchor: "start",
              },
            },
            {
              x: 68, // 5 PM
              strokeDashArray: 4, // Línea punteada
              borderColor: "#FF4560", // Color de la línea
              label: {
                style: {
                  color: "#fff",
                  background: "#FF4560",
                },
                text: "Fin Jornada (5 PM)",
                orientation: "horizontal",
                textAnchor: "start",
              },
            },
          ],
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "80%",
          },
        },
        markers: {
          size: 0,
        },
        fill: {
          opacity: 1,
          /*type: "gradient",
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [20, 100, 100, 100],
          },*/
        },
        yaxis: {
          labels: {
            style: {
              colors: "#8e8da4",
            },
            offsetX: 0,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          title: {
            text: "Cantidad de pedidos",
            rotate: -90,
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: "16px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 525,
              cssClass: "apexcharts-yaxis-title",
            },
          },
        },
        xaxis: {
          type: "datetime",
          categories: [],
          tickAmount: 12,
          labels: {
            //rotateAlways: true,
            formatter: function (val) {
              const horas = Math.floor(val / 4); // Obtener horas
              const minutos = Math.floor((val % 4) * 15); // Obtener minutos restantes
              const ampm = horas >= 12 ? "PM" : "AM"; // Determinar si es AM o PM
              const horasFormato12 = horas % 12 || 12; // Convertir a formato 12 horas

              return `${horasFormato12}:${minutos
                .toString()
                .padStart(2, "0")} ${ampm}`;
            },
          },
        },
        title: {
          text: "Pedidos por hora",
          align: "left",
          offsetX: 14,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return `${val} pedidos`;
            },
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          offsetX: -10,
        },
      },
      chartSeries2: [
        {
          name: "Pedido creado",
          data: [0],
          color: "#42A5F5",
        },
        {
          name: "Revisión de crédito",
          data: [1],
          color: "#27C26E",
        },
        {
          name: "Confirmación",
          data: [2],
          color: "#D5E343",
        },
        {
          name: "Facturación",
          data: [3],
          color: "#FA9477",
        },
        {
          name: "Prep. en almacén",
          data: [4],
          color: "#D40A0A",
        },
        {
          name: "Preparado",
          data: [5],
          color: "#0A44D4",
        },
        {
          name: "En ruta entrega",
          data: [6],
          color: "#6B99E5",
        },
      ],
    };
  },
  methods: {
    formatMinutes(minutes) {
      const duration = intervalToDuration({
        start: 0,
        end: minutes * 60 * 1000,
      });
      const { days, hours, minutes: mins } = duration;

      if (days === 0) {
        if (hours === 0) {
          return `${mins} minutos`;
        } else {
          return `${hours} horas, ${mins} minutos`;
        }
      } else {
        if (mins === 0) {
          return `${days} días, ${hours} horas`;
        } else {
          return `${days} días, ${hours} horas, ${mins} minutos`;
        }
      }
    },
    mostrarSucursal() {
      const ordenOriginal = this.sucursales.map((s) => s.value);
      this.sucursalesSelected.sort((a, b) => {
        return ordenOriginal.indexOf(a) - ordenOriginal.indexOf(b);
      });
      // console.log(this.sucursal);
    },
    async getReportes() {
      if (
        this.fechaInicial === "" ||
        this.fechaFin === "" ||
        this.sucursalesSelected.length === 0
      ) {
        alert("No puede haber campos vacios");
      } else {
        this.loadingBtn = true;
        console.log(this.fechaInicial);
        console.log(this.fechaFin);

        try {
          // Creamos un array de promesas utilizando map para hacer una solicitud por cada sucursal
          const promesasSolicitudes = this.sucursalesSelected.map(
            (sucursal) => {
              return axios
                .get(
                  `/reportes/pedidos?fecha_inicial=${this.fechaInicial}&fecha_final=${this.fechaFin}&sucursal=${sucursal}`
                )
                .then((response) => response.data) // Asegurarse de devolver los datos de la respuesta
                .catch((error) => {
                  console.error("Error al obtener datos:", error);
                  if (error.response.request.status === 404) {
                    return {
                      pedidos_entregados: 0,
                      pedido_creado: 0,
                      revision_de_credito: 0,
                      confirmacion: 0,
                      facturacion: 0,
                      preparacion_en_almacen: 0,
                      preparado: 0,
                      en_ruta_de_entrega: 0,
                    };
                  } else {
                    return null; // Devolver null o algún valor para manejar el error
                  }
                });
            }
          );

          // Usamos Promise.allSettled para esperar a que todas las promesas se resuelvan o rechacen
          const resultados = await Promise.allSettled(promesasSolicitudes);

          this.pedidosSucursales = resultados.map((result) => {
            const datosPedido = {
              pedidos_entregados: result.value.pedidos_entregados,
              totalMinutos:
                Math.round(result.value.pedido_creado / 60) +
                Math.round(result.value.revision_de_credito / 60) +
                Math.round(result.value.confirmacion / 60) +
                Math.round(result.value.facturacion / 60) +
                Math.round(result.value.preparacion_en_almacen / 60) +
                Math.round(result.value.preparado / 60) +
                Math.round(result.value.en_ruta_de_entrega / 60),
              series: [
                {
                  name: "Tiempo",
                  data: [
                    Math.round(result.value.pedido_creado / 60),
                    Math.round(result.value.revision_de_credito / 60),
                    Math.round(result.value.confirmacion / 60),
                    Math.round(result.value.facturacion / 60),
                    Math.round(result.value.preparacion_en_almacen / 60),
                    Math.round(result.value.preparado / 60),
                    Math.round(result.value.en_ruta_de_entrega / 60),
                  ],
                },
              ],
            };

            return datosPedido;
          });

          console.log(resultados);
          console.log(this.pedidosSucursales);
          this.loadingBtn = false;
          this.dialogAllReportes = true;
        } catch (error) {
          if (error.response.request.status === 404) {
            this.loadingBtn = false;
            alert(
              "No se encontraron datos para la fecha seleccionada o sucursal seleccionada"
            );
          }
          console.error("Error al obtener datos:", error);
        }
      }
    },

    async getReportesCumplimiento() {
      try {
        /*Limpia los datos del grafico de cumplimiento
        this.chartSeries2.forEach((serie) => (serie.data = []));
        this.chartOptions2.xaxis.categories = [];*/

        const response = await axios.get(
          `/reportes/get_cumplimiento_pedidos?fecha_inicial=${this.fechaInicial}&fecha_final=${this.fechaFin}&sucursal=${this.sucursalesSelected}`
        );
        this.pedidosCumplimiento = response.data;

        this.usuariosDisponibles = [
          ...new Set(this.pedidosCumplimiento.data.map((item) => item[8])),
        ];

        // 🟢 Mapeo de estados a índices en `chartSeries2`
        const estadoMap = {
          pedido_creado: 0,
          revision_de_credito: 1,
          confirmacion: 2,
          facturacion: 3,
          preparacion_en_almacen: 4,
          preparado: 5,
          en_ruta_de_entrega: 6,
        };

        // 🕒 Guardar las horas y las cantidades por estado
        const cantidadPorHora = {};
        // 🔄 Crear un array vacío para cada serie en `chartSeries2`
        this.chartSeries2.forEach((serie) => (serie.data = []));

        // 📌 Procesar los datos del backend
        this.pedidosCumplimiento.data.forEach((item) => {
          const timestamp = item[7]; // ⏳ Hora del pedido
          const estado = item[3]; // 📌 Estado

          // 📅 Convertir timestamp a hora y minuto
          const date = new Date(timestamp);
          const formattedTime = date.getTime();

          // Inicializar la estructura para las horas si no existe
          if (!cantidadPorHora[formattedTime]) {
            cantidadPorHora[formattedTime] = {};
          }

          // Incrementar la cantidad para el estado correspondiente
          if (!cantidadPorHora[formattedTime][estado]) {
            cantidadPorHora[formattedTime][estado] = 0;
          }
          cantidadPorHora[formattedTime][estado]++;
        });

        // 🧮 Ahora agregamos las cantidades a las series
        Object.keys(cantidadPorHora).forEach((hora) => {
          Object.keys(cantidadPorHora[hora]).forEach((estado) => {
            const estadoIndex = estadoMap[estado];
            if (estadoIndex !== undefined) {
              this.chartSeries2[estadoIndex].data.push({
                x: parseInt(hora), // Hora en el eje X
                y: cantidadPorHora[hora][estado], // Cantidad de pedidos para esa hora y estado
              });
            }
          });
        });

        // Ordenar las horas correctamente y agregar AM/PM
        const sortedTimestamps = Object.keys(cantidadPorHora).sort(
          (a, b) => a - b
        );
        this.chartOptions2.xaxis.categories = sortedTimestamps;

        this.$nextTick(() => {
          this.chartOptions2 = {
            ...this.chartOptions2,
          };
          this.chartSeries2 = [...this.chartSeries2];
        });

        console.log("chartSeries2 actualizada:", this.chartSeries2);
        console.log("pedidosCumplimiento:", this.pedidosCumplimiento);

        this.dialogAllReportes = true;
      } catch (error) {
        if (error.response.request.status === 404) {
          this.loadingBtn = false;
          alert(
            "No se encontraron datos para la fecha seleccionada o sucursal seleccionada"
          );
        }
        console.error("Error al obtener datos:", error);
      }
    },
    filtrarPorUsuario() {
      if (!this.usuarioSeleccionado) {
        // Si no hay usuario seleccionado, mostrar todos los datos
        this.getReportesCumplimiento();
        return;
      }

      // Filtrar los datos por el usuario seleccionado
      const datosFiltrados = this.pedidosCumplimiento.data.filter(
        (item) => item[8] === this.usuarioSeleccionado
      );

      //console.log("Datos filtrados antes de chart:", datosFiltrados);

      // Verificar si los datos filtrados tienen contenido válido
      const datosValidos = datosFiltrados.filter(
        (item) => item[7] && !isNaN(new Date(item[7]).getTime()) && item[3]
      );

      //console.log("Datos validos:", datosValidos);

      if (datosValidos.length === 0) {
        this.chartSeries2.forEach((serie) => (serie.data = []));
        this.chartOptions2.xaxis.categories = [];
        this.$nextTick(() => {
          this.chartOptions2 = {
            ...this.chartOptions2,
          };
          this.chartSeries2 = [...this.chartSeries2];
        });
        alert("No se encontraron datos para el usuario seleccionado.");
        return;
      }

      // 🟢 Mapeo de estados a índices en `chartSeries2`
      const estadoMap = {
        pedido_creado: 0,
        revision_de_credito: 1,
        confirmacion: 2,
        facturacion: 3,
        preparacion_en_almacen: 4,
        preparado: 5,
        en_ruta_de_entrega: 6,
      };

      // 🕒 Guardar las horas y las cantidades por estado
      const cantidadPorHora = {};

      this.chartSeries2.forEach((serie) => (serie.data = []));

      // 📌 Procesar los datos filtrados
      datosValidos.forEach((item) => {
        const timestamp = item[7]; // ⏳ Hora del pedido
        if (!timestamp || isNaN(new Date(timestamp).getTime())) {
          console.log("Formato de fecha incorrecto:", item[7]);
          return;
        }
        const estado = item[3]; // 📌 Estado

        const date = new Date(timestamp);
        const formattedTime = date.getTime();

        if (!cantidadPorHora[formattedTime]) {
          cantidadPorHora[formattedTime] = {};
        }

        if (!cantidadPorHora[formattedTime][estado]) {
          cantidadPorHora[formattedTime][estado] = 0;
        }
        cantidadPorHora[formattedTime][estado]++;
      });

      Object.keys(cantidadPorHora).forEach((hora) => {
        Object.keys(cantidadPorHora[hora]).forEach((estado) => {
          const estadoIndex = estadoMap[estado];
          if (estadoIndex !== undefined) {
            this.chartSeries2[estadoIndex].data.push({
              x: parseInt(hora),
              y: cantidadPorHora[hora][estado],
            });
          }
        });
      });

      const sortedTimestamps = Object.keys(cantidadPorHora).sort(
        (a, b) => a - b
      );
      this.chartOptions2.xaxis.categories = sortedTimestamps;

      this.$nextTick(() => {
        this.chartOptions2 = {
          ...this.chartOptions2,
        };
        this.chartSeries2 = [...this.chartSeries2];
      });

      console.log("Datos filtrados por usuario:", this.chartSeries2);
    },
  },
  watch: {},
  created() {
    // this.getDatos();
    // this.prepararDatos();
    //this.getReportesCumplimiento();
  },

  components: { apexchart: VueApexCharts },
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>
